import { Component, computed, inject, input, InputSignal } from '@angular/core';
import dayjs from 'dayjs';
import { Activity } from '../activities.types';
import { activityTypeLabels } from '../activities.constants';
import { ButtonComponent } from '../../../atoms/button/button.component';
import { ModalService } from '../../../../services/modal.service';
import { ModalViewActivityComponent } from '../../modal/modal-view-activity/modal-view-activity.component';

@Component({
  selector: 'app-activity-item',
  templateUrl: './activity-item.component.html',
  imports: [ButtonComponent],
})
export class ActivityItemComponent {
  readonly activity: InputSignal<Activity> = input.required();

  private readonly modalService = inject(ModalService);

  readonly activityTypeLabel = computed(() => activityTypeLabels[this.activity().type]);

  public get dateString(): string {
    const dateObject = dayjs(this.activity().scheduledDate, 'YYYY-MM-DD');
    return dateObject.format('dd, DD.MM.YYYY');
  }

  public openModal(): void {
    this.modalService.openOverlayWithConfig(ModalViewActivityComponent, {
      activity: this.activity(),
    });
  }
}
